package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SimulationW500Rounded: ImageVector
    get() {
        if (_simulationW500Rounded != null) {
            return _simulationW500Rounded!!
        }
        _simulationW500Rounded = Builder(name = "SimulationW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(423.5f, 501.28f)
                quadToRelative(-23.5f, -23.5f, -23.5f, -56.5f)
                reflectiveQuadToRelative(23.5f, -56.5f)
                quadToRelative(23.5f, -23.5f, 56.5f, -23.5f)
                reflectiveQuadToRelative(56.5f, 23.5f)
                quadToRelative(23.5f, 23.5f, 23.5f, 56.5f)
                reflectiveQuadToRelative(-23.5f, 56.5f)
                quadToRelative(-23.5f, 23.5f, -56.5f, 23.5f)
                reflectiveQuadToRelative(-56.5f, -23.5f)
                close()
                moveTo(122.63f, 375.89f)
                verticalLineToRelative(303.37f)
                quadToRelative(12.57f, 11.09f, 30.05f, 19.39f)
                quadToRelative(17.49f, 8.31f, 40.15f, 13.07f)
                verticalLineToRelative(-313.18f)
                quadToRelative(-19.37f, -4.52f, -37.24f, -10.18f)
                reflectiveQuadToRelative(-32.96f, -12.47f)
                close()
                moveTo(837.61f, 375.13f)
                quadToRelative(-15.09f, 6.8f, -32.58f, 12.47f)
                quadToRelative(-17.49f, 5.66f, -37.62f, 10.18f)
                verticalLineToRelative(313.94f)
                quadToRelative(22.66f, -5.0f, 40.14f, -13.19f)
                quadToRelative(17.49f, -8.18f, 30.06f, -19.27f)
                verticalLineToRelative(-304.13f)
                close()
                moveTo(31.87f, 683.83f)
                verticalLineToRelative(-400.72f)
                quadToRelative(0.0f, -63.46f, 114.7f, -96.97f)
                quadTo(261.26f, 152.63f, 480.0f, 152.63f)
                quadToRelative(218.98f, 0.0f, 333.67f, 33.51f)
                quadToRelative(114.7f, 33.51f, 114.7f, 96.97f)
                verticalLineToRelative(400.72f)
                quadToRelative(0.0f, 41.39f, -45.36f, 72.94f)
                quadToRelative(-45.36f, 31.56f, -130.79f, 49.75f)
                quadToRelative(-29.83f, 6.2f, -52.82f, -13.69f)
                quadToRelative(-22.99f, -19.9f, -22.99f, -50.2f)
                verticalLineToRelative(-348.26f)
                quadToRelative(0.0f, -30.54f, 20.11f, -54.27f)
                quadToRelative(20.11f, -23.73f, 50.65f, -29.21f)
                quadToRelative(27.9f, -6.28f, 48.48f, -12.71f)
                quadToRelative(20.59f, -6.42f, 31.59f, -13.7f)
                quadToRelative(-41.81f, -17.0f, -142.46f, -29.31f)
                quadToRelative(-100.65f, -12.3f, -204.78f, -12.3f)
                reflectiveQuadToRelative(-204.9f, 12.3f)
                quadToRelative(-100.77f, 12.31f, -142.58f, 29.31f)
                quadToRelative(11.0f, 7.28f, 31.71f, 14.2f)
                quadToRelative(20.7f, 6.93f, 48.84f, 13.21f)
                quadToRelative(30.54f, 6.48f, 50.65f, 29.21f)
                reflectiveQuadToRelative(20.11f, 53.27f)
                verticalLineToRelative(348.26f)
                quadToRelative(0.0f, 30.07f, -22.99f, 49.96f)
                reflectiveQuadToRelative(-52.82f, 13.93f)
                quadToRelative(-85.43f, -18.19f, -130.79f, -49.75f)
                quadToRelative(-45.36f, -31.55f, -45.36f, -72.94f)
                close()
                moveTo(122.63f, 375.89f)
                verticalLineToRelative(335.83f)
                verticalLineToRelative(-335.83f)
                close()
                moveTo(837.61f, 375.13f)
                verticalLineToRelative(336.59f)
                verticalLineToRelative(-336.59f)
                close()
                moveTo(480.0f, 564.78f)
                quadToRelative(67.93f, 0.0f, 112.17f, 25.9f)
                quadToRelative(44.24f, 25.91f, 44.24f, 71.1f)
                quadToRelative(0.0f, 10.0f, -6.5f, 16.5f)
                reflectiveQuadToRelative(-16.5f, 6.5f)
                lineTo(346.83f, 684.78f)
                quadToRelative(-10.0f, 0.0f, -16.5f, -6.5f)
                reflectiveQuadToRelative(-6.5f, -16.5f)
                quadToRelative(0.0f, -44.95f, 44.24f, -70.98f)
                quadTo(412.3f, 564.78f, 480.0f, 564.78f)
                close()
            }
        }
        .build()
        return _simulationW500Rounded!!
    }

private var _simulationW500Rounded: ImageVector? = null
